import { render, staticRenderFns } from "./pricing_card.vue?vue&type=template&id=6fffae08&scoped=true&"
import script from "./pricing_card.vue?vue&type=script&lang=js&"
export * from "./pricing_card.vue?vue&type=script&lang=js&"
import style0 from "./pricing_card.vue?vue&type=style&index=0&id=6fffae08&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fffae08",
  null
  
)

export default component.exports